// Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';

// Social Media Logos
import {
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  faTripadvisor,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons'

// Deep import so we don't need to import and tree/shake the whole collection
// -- Solid
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faBars } from '@fortawesome/pro-regular-svg-icons/faBars'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'

// add the imported icons to the library
library.add(
  faFacebook,
  faFoursquare,
  faGoogle,
  faInstagram,
  faLinkedin,
  faMedium,
  faPinterest,
  faTripadvisor,
  faTwitter,
  faUntappd,
  faVimeo,
  faYelp,
  faYoutube,
  faTimes,
  faBars,
  faArrowRight
);

// tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js